import { PENDING } from 'modules/common/constants/conversationStatuses';
import { addToast } from 'modules/messageSystem/actions/addToast';

import createAction from './';

export const SET_VIDEO_LAYOUT = createAction('SET_VIDEO_LAYOUT');

export const setVideoLayout = (value) => (dispatch, getState) => {
  const state = getState();
  const { selfVideoOff, localVideo } = state.conference.consultationInfo;
  const { videoDisabled } = state.conference.remoteMedia;
  const { status } = state.conference.currentConversation;
  const isInWainingRoom = status === PENDING;

  if ((selfVideoOff && videoDisabled) || isInWainingRoom) return;

  if (value && !localVideo) {
    return dispatch(addToast('info', 'no-local-video-toast', {
      id: 'const.noLocalVideoError',
      defaultMessage: '** No local video, try to reconnect',
    }, false, null, true, false, null, 3000, 'video'));
  }

  return dispatch({
    type: SET_VIDEO_LAYOUT,
    meta: { value },
  });
};
